import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'privacypolicy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['../pre-login.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  
  ngOnInit() {
    window.scrollTo(0, 0);
  }

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/privacy-policy/privacy-policy.component.ts